// extracted by mini-css-extract-plugin
export default {"contacts":"styles_contacts__P3Kau","mailNphone":"styles_mailNphone__vIOMx","socials":"styles_socials__T6vmh","invert":"styles_invert__QmlG2","big":"styles_big__NtEu0"};